import { createContext } from 'react'

import { BrowserService } from '@lib/services/browser'
import type { ServerService } from '@lib/services/server-data'
import { UserService } from '@lib/services/user'
// import { SubscriptionServiceImpl, SubscriptionService } from '@lib/services/subscription'
// import { UserJourneyService, UserJourneyServiceImpl } from './user-journey'
// import { LocalizedPricesIndiaService, LocalizedPricesIndiaServiceImpl } from './localized-prices-india'
// import { GeoLocationService } from './geo-location'

export interface CommonServices {
  readonly shWebServerService: ServerService
  readonly browserService: BrowserService
  readonly userService: UserService
  //   readonly subscriptionService: SubscriptionService
  //   readonly userJourneyService: UserJourneyService
  //   readonly localizedPricesIndiaService: LocalizedPricesIndiaService
  //   readonly geoLocationService: GeoLocationService
}

export const createCommonServices = (
  // apiService: ApiService,
  shWebServerFactory: () => ServerService,
): CommonServices => {
  const shWebServerService = shWebServerFactory()
  const browserService = new BrowserService(shWebServerService)
  const userService = new UserService(shWebServerService)
  //   const geoLocationService = new GeoLocationService(shWebServerService)
  //   const subscriptionService = new SubscriptionServiceImpl(shWebServerService)
  //   const userJourneyService = new UserJourneyServiceImpl(userService, browserService)
  //   const localizedPricesIndiaService = new LocalizedPricesIndiaServiceImpl(undefined, geoLocationService)

  return {
    shWebServerService,
    browserService,
    userService,
    //     subscriptionService,
    //     userJourneyService,
    //     localizedPricesIndiaService,
    //     geoLocationService,
  }
}

// export const apiService = new ApiService(fetch)

export const CommonServicesContext = createContext({} as CommonServices)
// export const ApiServiceContext = createContext(apiService)
